var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

var _isSP;
var windowW = window.innerWidth;
var prewidth = window.innerWidth;

//preload
import {preload} from "../include/module";
preload();

//showMovie
import {showMovie} from "../include/module";
showMovie();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

// pageTop
import {pageTop} from "../include/module";
pageTop();

// $(window).on('resize load' , function() {
//   if(windowW <= 1024){
//     _isSP = true;
//   } else {
//     _isSP = false;
//   };

//   //リサイズ処理 ブレイクポイントを跨いだらリロード
//   var nowWidth = window.innerWidth;
//   if(prewidth !== nowWidth){
//     if(prewidth < 1025) {
//       if(nowWidth >= 1025){
//         location.reload();
//       }
//     }else {
//       if(nowWidth < 1025){
//         location.reload();
//       }
//     }
//   };
// });


$(window).on('load' , function() {

  toggleBox();
  scrollCommonAnime();
  allCheck();

});


// ------------------------------------------------------------------------
// toggleBox
// ----- BOTH
// ------------------------------------------------------------------------
const toggleBox = () => {
  $("#add-Term").on("click", function() {
    $("#add-Term_Contents").toggleClass("is-show");
    $(this).toggleClass("opened");
  });
};

// ------------------------------------------------------------------------
// allCheck
// ----- BOTH
// ------------------------------------------------------------------------
const allCheck = () => {
  $(".checkbox-List li input.allcheck").change(function (e) {
    $(this).prop("checked") && ($(this).parents(".checkbox-List").find("input").prop("checked", !1), $(this).prop("checked", !0))
  }),
  $(".checkbox-List li input:not(.allcheck)").change(function (e) {
    $(this).prop("checked") && ( $(this).parents(".checkbox-List").find("input.allcheck").prop("checked", !1))
  })
};


  // ------------------------------------------------------------------------
// scrollCommonAnime
// ----- BOTH
// ------------------------------------------------------------------------
const scrollCommonAnime = () => {

  const controller = new ScrollMagic.Controller();

  //ヘッダー縮める
  const scene = new ScrollMagic.Scene({
    triggerElement:'.index-Keyvisual',
    triggerHook: 0,
    offset: '100'
  })
  .setClassToggle('#st-Header,#st-Header_Logo', 'short')
  // .addIndicators({name: "1"})
  .addTo(controller);

};



// WEBPACK FOOTER //
// ./src/en-shadowverse-evolve/assets/js/cards/script.js